export default __webpack_public_path__ + "static/media/pattern-fan2.76d54b5e.jpg";